import { api } from 'api'
import { ErrorsNoData } from 'constants/actionMessages'
import { createAsyncThunk } from 'modules/store'

export const getLanguages = createAsyncThunk('languages/getLanguages', api.languages.getLanguages, {
  error: ErrorsNoData.Languages,
})
